import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TransactionInfo } from "@/util/transfer-util";

export type TransferState =
  | {
      state: "None";
    }
  | {
      state: "WaitingForFirstAccount";
      // redirectUrl?: Href;
      transactions: TransactionInfo[];
    }
  | {
      state: "Transferring";
      // redirectUrl?: Href;
      transactions: TransactionInfo[];
    };

const initialState: TransferState = {
  state: "None",
};

const transferSlice = createSlice({
  name: "transfer",
  initialState: initialState as TransferState,
  reducers: {
    setTransferState: (_, action: PayloadAction<TransferState>) => {
      return action.payload;
    },
    resetTransferState: (): TransferState => {
      return { state: "None" };
    },
  },
});

export const { setTransferState, resetTransferState } = transferSlice.actions;

export default transferSlice.reducer;
